import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ReactSlider from "react-slider";
import { RenderThumbProps, RenderTrackProps } from 'react-slider';

const colorOptions: Option[] = [
  { label: "Black", value: "Black" },
  { label: "Gray", value: "Gray" },
  { label: "Silver", value: "Silver" },
  { label: "White", value: "White" },
  { label: "Blue", value: "Blue" },
  { label: "Green", value: "Green" },
  { label: "Red", value: "Red" },
  { label: "Brown", value: "Brown" },
  { label: "Gold", value: "Gold" },
  { label: "Beige", value: "Beige" },
];


const Sidebar = styled.div`
  width: 350px;
  padding: 16px;
  color: black;

  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  height: 100%;


  @media (max-width: 769px) {
    height: fit-content;
    width: 100%;
    box-shadow: none;


  }
`;

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 30px;
  
  margin-top: 10px;
`;

const StyledThumb = styled.div`
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #e61717;
  border-radius: 50%;
  cursor: grab;
  margin-bottom: -10px;

  &:focus {
    outline: none;
    border: 1px solid #e61717;
  }

  &:active {
    outline: none;
    border: 1px solid #e61717;
  }
`;


const StyledTrack = styled.div`
  top: 20%;
  height: 10px;
  border-radius: 50px;

  background: #ccc;

  &[data-index="1"] {
    background: #e61717;
  }
`;

const RangeSlider = (props: any) => (
  <StyledSlider
    {...props}
    renderThumb={(props: React.HTMLAttributes<HTMLDivElement>) => (
      <StyledThumb {...props} />
    )}
    renderTrack={(
      props: React.HTMLAttributes<HTMLDivElement>,
      state: { index: number }
    ) => (
      <StyledTrack {...props} data-index={state.index} />
    )}
  />
);



const Section = styled.div`
  margin-bottom: 30px;
`;

const Title = styled.h4`
margin-bottom: 4px;
font-weight: 600;
border:1px solid #ccc;
background:#e4e4e4;
border-radius:5px 5px 0 0 ;
padding: 4px 10px;
`;

const Titles = styled.h4`
  margin-bottom: 4px;
  font-weight: 600;
  border:1px solid #ccc;
  background:#e4e4e4;
  border-radius:5px 5px 0 0 ;
  padding: 4px 10px;
`;

const Input = styled.input`
  width: 100%;
  border-radius: 5px;
  padding: 8px 10px;
font-family:var(--font-normal);
  border: 1px solid #ddd;

`;

const OptionBlock = styled.div<{ selected: boolean }>`
  display: inline-block;
  padding: 5px 12px;
  margin: 4px;
  border-radius: 7px;
  font-size:15px;
  border: 1px solid ${({ selected }) => (selected ? "#fff" : "#ddd")};
  background-color: ${({ selected }) => (selected ? "#e61717" : "#f0f0f0")};
  color: ${({ selected }) => (selected ? "#fff" : "#333")};
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: ${({ selected }) => (selected ? "#e61717" : "#e0e0e0")};
  }
`;

const ColorBlock = styled.div<{ selected: boolean; color: string }>`
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 4px;

  border-radius: 50%;
  background-color: ${({ color }) => color.toLowerCase()};
  border: 2px solid ${({ selected }) => (selected ? "#e61717" : "#ccc")};
  cursor: pointer;
  position: relative;

  &:hover {
    opacity: 0.85;
  }


`;


type Option = {
  label: string;
  value: string;
};

type FiltersType = {
  yearMin?: string;
  yearMax?: string;
  make?: string[];
  model?: string[];
  trim?: string[];
  color?: string[];
  kmmax?: string;
  kmmin?: string;
  engine?: string[];
  transmission?: string[];
  drivetrain?: string[];
  sort?: string; // <-- new

};

const sortingOptions: Option[] = [
  { label: "Price: Low to High", value: "price_asc" },
  { label: "Price: High to Low", value: "price_desc" },
  { label: "KM: Low to High", value: "km_asc" },
  { label: "KM: High to Low", value: "km_desc" },
  { label: "Year: Old to New", value: "year_asc" },
  { label: "Year: New to Old", value: "year_desc" },
  { label: "Make: A to Z", value: "make_asc" },
  { label: "Make: Z to A", value: "make_desc" },
];


type FilterProps = {
  onFilterChange: (filters: FiltersType) => void;
  makeOptions: Option[];
  modelOptions: (make: string) => Promise<Option[]>;
  trimOptions: (make: string, model: string) => Promise<Option[]>;
};

const Filters = ({ onFilterChange, makeOptions, modelOptions, trimOptions }: FilterProps) => {
  const [filters, setFilters] = useState<FiltersType>({});
  const [models, setModels] = useState<{ [make: string]: Option[] }>({});
  const [trims, setTrims] = useState<{ [makeModel: string]: Option[] }>({});

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleSelect = (key: keyof FiltersType, value: string) => {
    const current = (filters[key] as string[]) || [];
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    const newFilters = {
      ...filters,
      [key]: updated.length > 0 ? updated : undefined,
    };

    setFilters(newFilters);
    onFilterChange(newFilters);

    // Special case: load models for selected makes
    if (key === "make") {
      const selectedMakes = updated;
      if (selectedMakes.length > 0) {
        Promise.all(selectedMakes.map(make => modelOptions(make)))
          .then((modelArrays) => {
            const newModels: { [make: string]: Option[] } = {};
            selectedMakes.forEach((make, index) => {
              newModels[make] = modelArrays[index];
            });
            setModels(newModels);
          });
      } else {
        setModels({});
      }
      setFilters((prev) => ({
        ...prev,
        model: [],
        trim: [],
      }));
      setTrims({});
    }

    if (key === "model" && updated.length > 0) {
      const selectedModels = updated;
      const selectedMakes = filters.make || [];
      const newTrims: { [makeModel: string]: Option[] } = {};
      Promise.all(
        selectedMakes.flatMap((make) =>
          selectedModels.map((model) => trimOptions(make, model))
        )
      ).then((trimArrays) => {
        let index = 0;
        selectedMakes.forEach((make) => {
          selectedModels.forEach((model) => {
            const makeModelKey = `${make}-${model}`;
            const trimOptions = trimArrays[index];
            if (trimOptions.length > 0) {
              newTrims[makeModelKey] = trimOptions;
            }
            index++;
          });
        });
        setTrims(newTrims);
      });
    }

    if (key === "model" && updated.length === 0) {
      setTrims({});
      setFilters((prev) => ({
        ...prev,
        trim: [],
      }));
    }
  };

  const renderColorBlocks = (options: Option[]) => {
    const selectedColors = (filters.color as string[]) || [];
    return options.map((opt) => (
      <ColorBlock
        key={opt.value}
        color={opt.value}
        selected={selectedColors.includes(opt.value)}
        onClick={() => handleSelect("color", opt.value)}
        title={opt.label} // Optional: Tooltip on hover
      />
    ));
  };

  
  const renderOptionBlocks = (key: keyof FiltersType, options: Option[]) => {
    const selectedValues = (filters[key] as string[]) || [];
    return options.map((opt) => (
      <OptionBlock
        key={opt.value}
        selected={selectedValues.includes(opt.value)}
        onClick={() => handleSelect(key, opt.value)}
      >
        {opt.label}
      </OptionBlock>
    ));
  };

  const renderModels = () => {
    return Object.entries(models).map(([make, modelOptions]) => (
      modelOptions.length > 0 && (
        <Section key={make}>
          <Title>{make} Models</Title>
          {renderOptionBlocks("model", modelOptions)}
        </Section>
      )
    ));
  };

  const renderTrims = () => {
    return Object.entries(trims).map(([makeModel, trimOptions]) => (
      trimOptions.length > 0 && (
        <Section key={makeModel}>
          <Titles>{makeModel} Trims</Titles>
          {renderOptionBlocks("trim", trimOptions)}
        </Section>
      )
    ));
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // adjust breakpoint if needed
    };

    handleResize(); // Check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Sidebar>
      <div style={{display:"flex",justifyContent:'space-between',alignItems:'center',marginBottom:15}}>
      <div style={{fontSize:20,      fontFamily:'var(--font-semiBold)'
}}>Filters</div>
  <button
    style={{
      backgroundColor: "#e61717",
    color: "white",
    padding: "6px 8px",
    borderRadius: "3px",
    border: "none",
    cursor: "pointer",
    width: "fit-content",
    fontSize: "12px",
    fontFamily: "var(--font-normal)",
    ...(isMobile ? { marginRight: "40px" } : {}),
    }}
    onClick={() => {
      setFilters({});
      onFilterChange({});
      setModels({});
      setTrims({});
    }}
  >
    Clear All Filters
  </button>
</div>
     <Section>
  <Title>Sort By</Title>
  <select
    style={{
      width: "100%",
      padding: "8px 5px",
      borderRadius: "5px",
      fontFamily: "var(--font-normal)",
      border: "1px solid #ddd",
    }}
    value={filters.sort || ""}
    onChange={(e) => {
      const newFilters = { ...filters, sort: e.target.value || undefined };
      setFilters(newFilters);
      onFilterChange(newFilters);
    }}
  >
    <option value="">None</option>
    <option value="price-asc">Price: Low to High</option>
    <option value="price-desc">Price: High to Low</option>
    <option value="km-asc">KM: Low to High</option>
    <option value="km-desc">KM: High to Low</option>
    <option value="year-asc">Year: Old to New</option>
    <option value="year-desc">Year: New to Old</option>
    <option value="make-asc">Make: A to Z</option>
    <option value="make-desc">Make: Z to A</option>
  </select>
</Section>


     <Section>
  <Title>Year</Title>
  <RangeSlider
    min={1990}
    max={2025}
    value={[Number(filters.yearMin) || 2000, Number(filters.yearMax) || 2022]}
    onChange={([min, max]: number[]) => {
      const newFilters = { ...filters, yearMin: String(min), yearMax: String(max) };
      setFilters(newFilters);
      onFilterChange(newFilters);
    }}
  />
  <div style={{ display: "flex", gap: "8px" }}>
    <Input
      type="number"
      name="yearMin"
      placeholder="From"
      value={filters.yearMin || "2000"}
      onChange={handleInputChange}
    />
    <Input
      type="number"
      name="yearMax"
      placeholder="To"
      value={filters.yearMax || "2022"}
      onChange={handleInputChange}
    />
  </div>
</Section>

      <Section>
        <Title>Make</Title>
        {renderOptionBlocks("make", makeOptions)}
      </Section>

      {renderModels()}

      {renderTrims()}

      <Section>
  <Title>Color</Title>
  {renderColorBlocks(colorOptions)}
</Section>


      <Section>
  <Title>Mileage (KM)</Title>
  <RangeSlider
    min={0}
    max={300000}
    step={10}
    value={[Number(filters.kmmin) || 0, Number(filters.kmmax) || 150000]}
    onChange={([min, max]: number[]) => {
      const newFilters = { ...filters, kmmin: String(min), kmmax: String(max) };
      setFilters(newFilters);
      onFilterChange(newFilters);
    }}
  />
  <div style={{ display: "flex", gap: "8px" }}>
    <Input
      type="number"
      name="kmmin"
      placeholder="Min KM"
      value={filters.kmmin || "0"}
      onChange={handleInputChange}
    />
    <Input
      type="number"
      name="kmmax"
      placeholder="Max KM"
      value={filters.kmmax || "150000"}
      onChange={handleInputChange}
    />
  </div>
</Section>

      <Section>
        <Title>Engine</Title>
        {renderOptionBlocks("engine", [
          { label: "3 Cylinder", value: "3 Cylinder" },
          { label: "4 Cylinder", value: "4 Cylinder" },
          { label: "6 Cylinder", value: "6 Cylinder" },
          { label: "8 Cylinder", value: "8 Cylinder" },
          { label: "10+ Cylinder", value: "10+ Cylinder" },
          { label: "Electric Motor", value: "Electric Motor" },
          { label: "Hybrid", value: "Hybrid" },
          { label: "Unknown", value: "Unknown" },
          
        ])}
      </Section>

      <Section>
        <Title>Transmission</Title>
        {renderOptionBlocks("transmission", [
          { label: "Auto", value: "Auto" },
          { label: "Manual", value: "Manual" },
        ])}
      </Section>
      <Section>
        <Title>Drivetrain</Title>
        {renderOptionBlocks("drivetrain", [
          { label: "AWD", value: "AWD" },
          { label: "FWD", value: "FWD" },
          { label: "4WD", value: "4WD" },
          { label: "RWD", value: "RWD" },

        ])}
      </Section>
    </Sidebar>
  );
};

export default Filters;
